<div class="flex">
	<form
		#myForm="ngForm"
		(ngSubmit)="_onSubmit(myForm)"
		class="flex items-center justify-between gap-3 w-full"
	>
		<app-checkbox
			type="clear"
			label="Calculate fee based on all-inclusive price"
			[(ngModel)]="setFee"
			name="setFee"
		></app-checkbox>
		<div class="flex gap-x-2 items-end">
			<app-input
				[(ngModel)]="amount"
				[startIcon]="ICON.DOLLAR"
				[disabled]="!setFee"
				type="cents"
				orientation="row"
				name="amount"
			></app-input>
			<app-button
				*ngIf="initialSetFee !== setFee || initialAmount !== amount"
				type="submit"
				[loading]="saving"
				[@fade]
				>Save</app-button
			>
		</div>
	</form>
</div>
